<button class="add-column-button" (click)="addColumn()" title="Add column">+</button>
